"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unBlur = exports.pulse = exports.spinCounterclockwise = exports.spinClockwise = void 0;

var _core = require("@emotion/core");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    filter: blur(4px);\n  }\n  100% {\n    filter: blur(0px);\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    opacity: .6;\n  }\n  50% {\n    opacity: 1;\n  }\n  100% {\n    opacity: .6;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(-359deg);\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(359deg);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var spinClockwise = (0, _core.keyframes)(_templateObject());
exports.spinClockwise = spinClockwise;
var spinCounterclockwise = (0, _core.keyframes)(_templateObject2());
exports.spinCounterclockwise = spinCounterclockwise;
var pulse = (0, _core.keyframes)(_templateObject3());
exports.pulse = pulse;
var unBlur = (0, _core.keyframes)(_templateObject4());
exports.unBlur = unBlur;